export const pMinDelay = async <T>(
  promise: Promise<T>,
  minimumDelay: number,
  options: { delayRejection?: boolean } = {}
): Promise<T> => {
  const ammendedOptions = {
    delayRejection: true,
    ...options,
  };

  let promiseError;
  let ammendedPromise: Promise<T>;

  if (ammendedOptions.delayRejection) {
    ammendedPromise = promise.catch<T>((error) => {
      promiseError = error;
      return Promise.reject<T>(promiseError);
    });
  } else {
    ammendedPromise = promise;
  }

  const value = await Promise.all<T, undefined>([
    ammendedPromise,
    new Promise((resolve) => setTimeout(resolve, minimumDelay)),
  ]);
  return promiseError ? Promise.reject(promiseError) : value[0];
};
